import { render, staticRenderFns } from "./SystemDevelopment.vue?vue&type=template&id=04f641e6&scoped=true&"
import script from "./SystemDevelopment.vue?vue&type=script&lang=js&"
export * from "./SystemDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f641e6",
  null
  
)

export default component.exports